import { Action as BaseAction } from '@ngrx/store';

export enum ActionTypes {
  LoadData = 'Data.LoadData',
  SortData = 'Data.SortData',
}

export type Action = LoadData | SortData;

export type LoadDataPayload = any;

export class LoadData implements BaseAction {
  readonly type = ActionTypes.LoadData;
  constructor(public payload: LoadDataPayload) {}
}

export interface SortDataPayload {
  key: string;
  direction: string;
}

export class SortData implements BaseAction {
  readonly type = ActionTypes.SortData;
  constructor(public payload: SortDataPayload) {}
}
